import { testimonials } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';

const avatarTones = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-800',
  'bg-background-200 text-foreground-700',
];

export default function ReviewsSection() {
  return (
    <section className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="REVIEWS"
        title="他们这样评价糖心吃瓜网"
        desc="来自不同生活节奏的人，在各自的缝隙时间里，把这里当成了一个小小的快乐补给站。"
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {testimonials.map((item, index) => (
          <figure
            key={item.name}
            className="flex h-full flex-col rounded-2xl border border-background-200/70 bg-background-50 p-5"
          >
            <i className="ri-double-quotes-l w-7 h-7 flex items-center justify-center text-3xl text-primary-300" />
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
              {item.text}
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
              <span
                className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-base ${
                  avatarTones[index % avatarTones.length]
                }`}
              >
                {item.name.slice(0, 1)}
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                <span className="block text-xs text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}